import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { NvPill } from "./nv-pill";

// 유형 · 도입 형태 태그: 마우스를 올리면 정의 문구 툴팁 (IA 65 · 73, slide 7 No.17).
// 툴팁 시안은 Figma에 없어서 Navigator 글자 · 색 토큰으로 그려요.
export interface NvTagValue {
  label: string;
  definition?: string | null;
}

export interface NvTagPillProps extends NvTagValue {
  className?: string;
}

function NvTagPill({ label, definition, className }: NvTagPillProps) {
  if (!definition) return <NvPill className={className}>{label}</NvPill>;
  return (
    <Tooltip delayDuration={150}>
      <TooltipTrigger asChild>
        <NvPill tabIndex={0} className={cn("relative z-10 cursor-help", className)}>
          {label}
        </NvPill>
      </TooltipTrigger>
      <TooltipContent className="rounded-nv-pill bg-nv-surface-inverse px-3 py-2 text-[12px] leading-[18px] text-nv-text-inverse">
        <span className="font-bold">{label}</span> · {definition}
      </TooltipContent>
    </Tooltip>
  );
}

export { NvTagPill };
